/** The same arithmetic the database does (migration 610000), for the figure shown while typing. */
export function logVolume(lengthM: number | null, girthCm: number | null, pieces: number | null, formula: string): number | null {
  if (!lengthM || !girthCm || lengthM <= 0 || girthCm <= 0) return null;
  const n = pieces && pieces > 0 ? pieces : 1;
  const one = formula === 'true_mid_girth' ? (girthCm / 100) ** 2 * lengthM / (4 * Math.PI) : (girthCm / 400) ** 2 * lengthM;
  return Math.round(n * one * 10000) / 10000;
}
